/**
 * The client's custom service level an inbound value names, such as a CSV "Customer Service Level" cell. A level
 * with a code matches only on its code (trimmed, any case); a level with no code matches on its exact name. A code
 * match wins. onward-functions' findServiceLevel (Centiro ingest) applies the same rule.
 * @param {{ service_level_id: string, service_level: string, code?: string }[]} serviceLevels
 * @param {string} value
 * @returns {object|undefined} The matching level, or undefined.
 */
export const findServiceLevel = (serviceLevels = [], value) => {
    if (!value) {
        return undefined;
    }

    const code = String(value).trim().toUpperCase();
    return (
        serviceLevels.find((sl) => sl.code && sl.code.trim().toUpperCase() === code) ||
        serviceLevels.find((sl) => !sl.code && sl.service_level === value)
    );
};
